import React from 'react';
import { Component } from "react";
import enUS from '../tokens/en-US.json';
import esES from '../tokens/es-ES.json';
import jpJP from '../tokens/jp-JP.json';
import ptBR from '../tokens/pt-BR.json';
import { translations } from './Text';

class Tooltip extends Component {
constructor(props){
    super(props);
    // this.state = [

    // ]
}
render(){
   
return(
<div className=''>
    {this.props.translations}
</div>
)
}

};

export default Tooltip;